import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { Link, navigate } from "@reach/router";
import {
  Title,
  Paragraph,
  SubTitle,
  DocImage,
  DocImages,
  NavigateButton,
  DocPaper,
  DocLink,
  Panel,
  Text,
  TextButton,
  TabWithContent,
  useDynamicImage,
  SimpleGallery
} from "../../../DocCreater";

//本文档的引用图片存放的位置
const imageFolder = "/images/learnpage/step4/";

//实验详述文档
const DocPanel = props => {
  return (
    <TabWithContent
      content={[
        {
          title: "实验步骤",
          detail: (
            <>
              <Paragraph>
                <Text color="secondary">虚拟搭建模块:</Text>
                虚拟搭建模块：选取清雍正十二年（1734年）清朝工部颁布的《工程做法》中建筑、斗栱样例作为虚拟搭建对象，并参考梁思成先生《清式营造则例》、《清工部〈工程做法〉图解》等书，通过三维建模软件，制作高仿真度的模型，严谨地再现清代官式大木建筑的风貌。实验包括平身科与歇山大木虚拟搭建两个搭建场景，通过这两个搭建场景，可以囊括清官式大木作的绝大部分构件与知识点；共包括平身科搭建实验、柱额层搭建实验、斗栱层搭建实验、屋架层搭建实验、椽望层搭建实验五个子实验，每个部分均提供测试模式、教学模式、查看模式，方便学生自主学习、自主测试；学生在对构件基础知识熟练掌握的基础上，进一步通过此模块的学习，动手实践一整座清代官式建筑大木作部分的完整建造过程，最终熟练掌握清代官式建筑构造。
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}buzhou/buzhou7-1.jpg`} />
              <Paragraph>
                学生点击导航栏“虚拟搭建”栏目，进入虚拟搭建模块，本模块实验较大，请耐心等待资源加载，可开启浏览器缓存，方便下次使用使减少加载时间，实验提供平身科与歇山大木两个搭建场景，3D场景内均使用鼠标右键移动视角、滚轮滑动缩放、按住滚轮平移。
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}buzhou/buzhou7-2.jpg`} />
              <DocImage imageSrc={`${imageFolder}buzhou/buzhou7-3.jpg`} />

              <Paragraph>
                <Text color="secondary">步骤7:</Text>
                选择平身科搭建场景，点击模型查看模式，在查看模式内，点击右侧面板对应的构件名称，实物中相应的构件会标红显示，点击相应的构件，则面板内构件名称会标红显示，同时场景左上角显示构件描述；点击右上方图标，可快速切换三视图查看模型，点击灯光按钮，为暗处补光，方便查看暗部构件；利用此模式交互式的学习平身科构造；
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou8.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤8:</Text>
                在平身科搭建场景，选择教学模式，点击右侧工坊内构件，即可生成相应构件，使用鼠标拖动或键盘WASDQE操作构件移动，使用空格按钮或左侧面板箭头切换构件方向位置，逐层进行平身科的组装，构件成功安装后，会显示反馈信息；教学模式中可实时查看各个构件在模型中的位置，可使用左侧菜单查看提示信息，获得帮助并快速搭建；通过本步骤，学生可在有指导的情况下，完成平身科搭建，深入学习平身科构造；
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou9.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤9:</Text>
                使用测试模式，对自身学习成果进行测试，独立完成平身科的搭建实验，并获得成绩记录，搭建交互操作方法与步骤8相同，但是无法使用教学模式中的提示引导功能，右侧面板会记录学生剩余需要安装的构件数量与测试时间，完成平身科搭建后会将此次测试成绩发送至服务器，未完成实验不记录成绩；
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou10.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤10:</Text>
                完成平身科搭建实验后，选择歇山大木搭建场景，选择模型查看模式，在查看模式内，点击右侧面板对应的构件名称，实物中相应的构件会标红显示，点击相应的构件，则面板内构件名称会标红显示，同时场景左上角显示构件描述；点击右上方图标，可快速切换三视图查看模型，点击灯光按钮，为暗处补光，方便查看暗部构件；利用此模式交互式的学习歇山大木构架的组合搭建方式；
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou11-1.jpg`} />
              <DocImage imageSrc={`${imageFolder}buzhou/buzhou11-2.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤11:</Text>
                在歇山大木搭建场景，选择教学模式，点击右侧工坊内构件，即可生成相应构件，使用鼠标拖动或键盘WASDQE操作构件移动，使用空格按钮或左侧面板箭头切换构件方向位置，进行歇山大木的组装，构件成功安装后，会显示反馈信息；教学模式中可实时查看各个构件在模型中的位置，可使用左侧菜单查看提示信息，获得帮助并快速搭建；通过本步骤，学生可在有指导的情况下，完成歇山大木的搭建，深入学习完整的歇山大木作构造；
              </Paragraph>

              <DocImage imageSrc={`${imageFolder}buzhou/buzhou12.jpg`} />
              <Paragraph>
                <Text color="secondary">步骤12:</Text>
                使用测试模式，按顺序完成柱额层、斗栱层、屋架层、椽望层四个搭建测试实验，独立完成四个部分的搭建，并获得成绩记录，搭建交互操作与步骤11相同，但是无法使用教学模式中的提示引导功能，右侧面板会记录学生剩余需要安装的构件数量与测试时间，完成各层搭建实验后会将此次测试成绩发送至服务器，未完成实验不记录成绩；
              </Paragraph>
              <DocLink to="/virtuallearn" newpage>
                前往虚拟搭建实验页面
              </DocLink>
            </>
          )
        },
        {
          title: "学术基础",
          detail: (
            <>
              <Paragraph>
                清雍正十二年（1734年）刊行的《工程做法》是清朝工部颁布的建筑术书，与宋代《营造法式》一起是研究我国古代建筑的最重要的两部文献。该书内容以工料额限为主，列举了二十七种建筑物的构件的结构、尺寸，以及各式斗栱、小木作、石作、瓦作等做法和尺寸。
              </Paragraph>
              <Paragraph>
                本实验中用于虚拟搭建的模型制作依据清雍正十二年（1734年）刊行的《工程做法》，选取书中建筑、斗栱样例作为虚拟搭建对象，并参考梁思成先生《清式营造则例》、《清工部〈工程做法〉图解》，以期严谨地再现清代官式大木建筑的风貌。模型仿真度高，各个构件全部比例均有相应文献支撑，平身科模型共计43个构件、歇山大木模型共计610个构件，模型精细度与学术性远胜于市面上普通的虚拟建筑模型或木制实物模型；
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}02.jpg`} />
            </>
          )
        },

        {
          title: "技术路线",
          detail: (
            <>
              <Paragraph>
                本虚拟搭建实验开发主要依靠Unity3d引擎，编程语言为C#。建模软件采用Rhino5.0和Maya，材质纹理依靠Substance
                painter，美工设计使用Photoshop。
              </Paragraph>
              <DocImage imageSrc={`${imageFolder}03.jpg`} />
            </>
          )
        }
      ]}
    />
  );
};

//操作指南文档
const OpGuide = props => {
  //生成Gallery的图片信息Array供SimpleGallery使用
  const galleryImages = [...Array(14)].map((currentValue, index) => {
    return {
      image: `${imageFolder}/opGuide/${String(index + 1).padStart(2, "0")}.JPG`,
      thumbnail: `${imageFolder}/opGuide/thumbs/${String(index + 1).padStart(
        2,
        "0"
      )}.JPG`
    };
  });
  return (
    <>
      <Paragraph>
        实验操作方式可进入实验后查看详细操作指南图文说明，实验中会在页面底部滚动提示重要的操作细节。
      </Paragraph>

      <SimpleGallery
        thumbHeight={135}
        thumbWidth={240}
        images={galleryImages}
      />
    </>
  );
};

// Panel方式交互展示文档
const resourcesPanelContent = [
  {
    panelTitle: <Text color="primary">实验介绍及步骤</Text>,
    panelDetail: <DocPanel />
  },
  {
    panelTitle: <Text color="primary">实验操作指南</Text>,
    panelDetail: <OpGuide />
  }
];

function Step4(props) {
  return (
    <DocPaper>
      <Title>清官式建筑大木作虚拟搭建实验</Title>
      {resourcesPanelContent.map(({ panelTitle, panelDetail }, index) => (
        <Panel
          panelTitle={panelTitle}
          panelDetail={panelDetail}
          key={index}
          defaultOpen={index === 0 ? true : false}
        />
      ))}
      <NavigateButton
        icon
        to="/learn/step/5"
        buttonText="下一步"
        iconStyle={{
          float: "right"
        }}
      />
    </DocPaper>
  );
}

export default Step4;
